import { reactive } from "vue";

export const clienteInadimplenciaStore = reactive({
  bloquearVendaClienteInadimplente: false,
  limiteInadimplenciaPermitida: 0,
});
